import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

const Notice = styled.aside`
    margin-bottom: 18px;
    padding: 16px;
    border: 1px solid rgba(240, 194, 123, 0.34);
    border-radius: var(--radius-md);
    background: rgba(240, 194, 123, 0.07);

    h2 {
        margin: 0 0 5px;
        color: var(--text);
        font-size: 16px;
    }

    p {
        margin: 0;
        color: var(--text-soft);
        font-size: 14px;
    }

    button {
        width: 100%;
        min-height: 44px;
        margin-top: 14px;
        border: 1px solid rgba(240, 194, 123, 0.42);
        border-radius: var(--radius-sm);
        background: transparent;
        color: #f7d7a4;
        font-weight: 750;
        cursor: pointer;
    }

    @media (min-width: 620px) {
        display: grid;
        grid-template-columns: 1fr auto;
        align-items: center;
        gap: 6px 20px;

        button {
            width: auto;
            min-width: 130px;
            margin: 0;
            grid-column: 2;
            grid-row: 1 / 3;
        }
    }

    @media (max-width: 480px) {
        padding: 12px;

        p { display: none; }
        button { margin-top: 8px; }
    }
`;

const ProfileMessages = () => {
    const navigate = useNavigate();

    return (
        <Notice role="status">
            <h2>Complete your profile first</h2>
            <p>Add a display name and Telegram username, then enable search visibility.</p>
            <button type="button" onClick={ () => navigate("/profile", { replace: true }) }>
                Edit profile
            </button>
        </Notice>
    );
};

export default ProfileMessages;
